<div class="n-contact-list-page">
  <div class="n-list-component-header">
    <h2>List of contacts</h2>
    <div>
      <!-- <button matIconButton matTooltip="Here comes the info"><mat-icon>info</mat-icon></button> -->
      <button matIconButton matTooltip="Select columns"
        (click)="openColumnSelector()"><mat-icon>view_column</mat-icon></button>
    </div>
  </div>

  <form [formGroup]="filterForm" class="n-filters-form">
    <div>
      <mat-expansion-panel [(expanded)]="filtersExpanded" #filtersPanel style="margin: 5px 0px; flex-grow: 1; ">
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>search</mat-icon> Filters </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="n-filter-form-row" style="align-items: flex-start;">
          <div class="n-select-filter-field-column">
            <mat-form-field class="n-search-field n-filter-flex-unit.simple" style="width: 100%">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput placeholder="First or last name" #simpleFilterInput formControlName="textFilter">
            </mat-form-field>
            <app-advanced-select #topicsSelect formControlName="topics" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Topics of interest" [options]="allTopicOptions()"
              [showAllOrAny]="showAllOrAny()" />
          </div>
          <div class="n-select-filter-field-column">
            <app-advanced-select #projectsSelect formControlName="projects" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Projects" [options]="allProjectOptions()"
              [showAllOrAny]="showAllOrAny()" />
            <app-advanced-select #initiativesSelect formControlName="initiatives" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Initiatives" [options]="allInitiativeOptions()"
              [showAllOrAny]="showAllOrAny()" />
          </div>
          <div class="n-select-filter-field-column">
            <app-advanced-select #stakeholderGroupsSelect formControlName="stakeholderGroups"
              [resetTrigger]="resetCounter" class="n-search-field n-filter-flex-unit" label="Stakeholder groups"
              [options]="allStakeholderGroupOptions()" [showAllOrAny]="showAllOrAny()" />
            <app-advanced-select #eventsSelect formControlName="events" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Events" [options]="allEventOptions()"
              [showAllOrAny]="showAllOrAny()" />
          </div>
          <div class="n-select-filter-field-column">
            <app-advanced-select #organisationsSelect formControlName="organisations" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Organisations" [options]="allOrganisationOptions()"
              [showAllOrAny]="showAllOrAny()" />
            <app-advanced-select #contactTypesSelect formControlName="contactTypes" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Contact type" [options]="allMemberContactTypeOptions"
              [showAllOrAny]="showAllOrAny()" />
          </div>
          <div class="n-select-filter-field-column">
            <app-advanced-select #countriesSelect formControlName="countries" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Countries" [options]="allCountryOptions()"
              [showAllOrAny]="showAllOrAny()" />
            <app-advanced-select #optOutSelect formControlName="communicationChoices" [resetTrigger]="resetCounter"
              class="n-search-field n-filter-flex-unit" label="Communication preferences"
              [options]="allCommunicationChoiceOptions" [showAllOrAny]="showAllOrAny()" [showSelectClearAll]="false" />
          </div>
          <button matFab (click)="clearAllFilters()" class="n-filter-reset-button"
            matTooltip="Clear all filters"><mat-icon>clear</mat-icon></button>
        </div>
        <div class="n-lcr-left">
          Show
          <mat-checkbox formControlName="showActiveItems"> active items
          </mat-checkbox>
          <mat-checkbox formControlName="showArchivedItems"> archived items
          </mat-checkbox>
        </div>
      </mat-expansion-panel>
    </div>
  </form>

  <div class="n-table-wrapper">
    @if (loading) {
    <div class="n-spinner-overlay">
      <mat-spinner></mat-spinner>
    </div>
    }
    <div class="n-table-scroll">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        <ng-container matColumnDef="valid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Is data valid?"><mat-icon>check</mat-icon>
          </th>
          <td mat-cell *matCellDef="let contact">
            @if (contact.validityStatus() === ValidityStatus.INVALID) {
            <span class="material-symbols-outlined n-invalid-status"
              matTooltip="Record is missing required data">error</span>
            } @else if (contact.validityStatus() === ValidityStatus.INCOMPLETE) {
            <span class="material-symbols-outlined n-incomplete-status"
              matTooltip="Record is missing important data">warning</span>
            } @else if (contact.validityStatus() === ValidityStatus.VALID) {
            <span class="material-symbols-outlined n-valid-status" matTooltip="Record is valid">verified</span>
            } @else {
            <span class="material-symbols-outlined">cruelty_free</span>
            }
          </td>
        </ng-container>

        <!-- firstName Column -->
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>First name</th>
          <td mat-cell *matCellDef="let contact">{{ contact.firstName }}</td>
        </ng-container>

        <!-- lastName Column -->
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last name</th>
          <td mat-cell *matCellDef="let contact">{{ contact.lastName }}</td>
        </ng-container>

        <!-- email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>email</th>
          <td mat-cell *matCellDef="let contact">{{ contact.email1 }}</td>
        </ng-container>

        <!-- organisation Column -->
        <ng-container matColumnDef="organisation">
          <th mat-header-cell *matHeaderCellDef>Organisation</th>
          <td mat-cell *matCellDef="let contact">
            <mat-chip-set class="n-my-chip">
              @for (affiliation of contact.affiliations; track affiliation.id) {
              @if (affiliation.organisation?.name) {
              <mat-chip [matTooltip]="affiliation.organisation?.name">
                <span>{{ affiliation.organisation?.name }}
                  @if (affiliation.organisation?.member) {
                  <span class="material-symbols-outlined"
                    style="display: inline-block; vertical-align: middle;">family_star</span>
                  }
                  @if (affiliation.organisation?.supplier) {
                  <span class="material-symbols-outlined"
                    style="display: inline-block; vertical-align: middle;">partner_exchange</span>
                  }
                </span>
              </mat-chip>
              }
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- topics Column -->
        <ng-container matColumnDef="topics">
          <th mat-header-cell *matHeaderCellDef>Topics of interest</th>
          <td mat-cell *matCellDef="let contact">
            <mat-chip-set class="n-my-chip">
              @for (topic of contact.topics; track topic.id) {
              <mat-chip [matTooltip]="topic.name"><span>{{ topic.name }}</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- stakeholderGroups Column -->
        <ng-container matColumnDef="stakeholderGroups">
          <th mat-header-cell *matHeaderCellDef>Stakeholder Groups</th>
          <td mat-cell *matCellDef="let contact">
            <mat-chip-set class="n-my-chip">
              @for (group of contact.stakeholderGroups; track group.id) {
              <mat-chip [matTooltip]="group.name"><span>{{ group.name }}</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- projects Column -->
        <ng-container matColumnDef="projects">
          <th mat-header-cell *matHeaderCellDef>Projects</th>
          <td mat-cell *matCellDef="let contact">
            <mat-chip-set class="n-my-chip">
              @for (project of contact.projects; track project.id) {
              <mat-chip [matTooltip]="project.name"><span>{{ project.name }}</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- initiatives Column -->
        <ng-container matColumnDef="initiatives">
          <th mat-header-cell *matHeaderCellDef>Initiatives</th>
          <td mat-cell *matCellDef="let contact">
            <mat-chip-set class="n-my-chip">
              @for (initiative of contact.initiatives; track initiative.id) {
              <mat-chip [matTooltip]="initiative.name"><span>{{ initiative.name }}</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- events Column -->
        <ng-container matColumnDef="events">
          <th mat-header-cell *matHeaderCellDef>Events</th>
          <td mat-cell *matCellDef="let contact">
            <mat-chip-set class="n-my-chip">
              @for (event of contact.events; track event.id) {
              <mat-chip [matTooltip]="event.name"><span>{{ event.name }}</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- countries Column -->
        <ng-container matColumnDef="countries">
          <th mat-header-cell *matHeaderCellDef>Country </th>
          <td mat-cell *matCellDef="let contact">
            <mat-chip-set class="n-my-chip">
              @for (countryCode of getAllCountries(contact); track countryCode) {
              <mat-chip [matTooltip]="countryNames().get(countryCode)">
                <span>{{ iso3ToEmojiFlag(countryCode) }}</span>
              </mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- contactTypes Column -->
        <ng-container matColumnDef="contactTypes">
          <th mat-header-cell *matHeaderCellDef>Contact type</th>
          <td mat-cell *matCellDef="let contact">
            <mat-chip-set class="n-my-chip">
              @if (hasPrimary(contact)) {
              <mat-chip matTooltip="Primary contact"> <span class="material-icons"
                  style="display: inline-block; vertical-align: middle;">account_circle</span></mat-chip>
              }
              @if (hasInvoicing(contact)) {
              <mat-chip matTooltip="Invoicing contact">
                <span class="material-symbols-outlined"
                  style="display: inline-block; vertical-align: middle;">receipt</span>
              </mat-chip>
              }
              @if (hasContract(contact)) {
              <mat-chip matTooltip="Contract contact">
                <span class="material-symbols-outlined"
                  style="display: inline-block; vertical-align: middle;">card_travel</span>
              </mat-chip>
              }
              @if (contact.boardOfDirectors) {
              <mat-chip matTooltip="Board of Directors"><span>BOD</span></mat-chip>
              }
              @if (contact.scientificAdvisoryBoard) {
              <mat-chip matTooltip="Scientific Advisory Board"><span>SAB</span></mat-chip>
              }
              @if (contact.generalAssembly) {
              <mat-chip matTooltip="General Assembly"><span>GA</span></mat-chip>
              }
              @if (contact.executiveCommittee) {
              <mat-chip matTooltip="Executive Committee"><span>Executive</span></mat-chip>
              }
              @if (contact.nominationCommittee) {
              <mat-chip matTooltip="Nomination Committee"><span>Nomination</span></mat-chip>
              }
              @if (contact.ethicsCommittee) {
              <mat-chip matTooltip="Ethics Committee"><span>Ethics</span></mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- lastModifiedOn Column -->
        <ng-container matColumnDef="lastModifiedOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last modification</th>
          <td mat-cell *matCellDef="let contact">
            {{ contact.lastModifiedOn | date:'dd/MM/yyyy HH:mm' }}
          </td>
        </ng-container>

        <tr mat-header-row class="n-grid-header-row" *matHeaderRowDef="selectedColumns"
          [ngStyle]="{ 'grid-template-columns': gridTemplate }">
        </tr>
        <tr mat-row class="n-grid-data-row" [class.n-archived-row]="row.archived"
          *matRowDef="let row; columns: selectedColumns" [ngStyle]="{ 'grid-template-columns': gridTemplate }"
          (click)="goToDetail(row)">
        </tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter</td>
        </tr>
      </table>
    </div>

    <mat-paginator #paginator class="demo-paginator" showFirstLastButtons="true" hidePageSize="false"
      [pageSizeOptions]="[5,10,25]" aria-label="Select page" />

    <div class="n-lcr-row">
      <div class="n-lcr-left">&nbsp;</div>
      <div class=" n-lcr-center" style="display:flex; gap: 5px; align-items: center; justify-content: center;"> <button
          matFab extended class="n-save-button" (click)="add()"><mat-icon>add</mat-icon>Add
          contact</button>
        <button matFab extended class="n-export-button" (click)="export()"><mat-icon>file_download</mat-icon>Export
        list</button>
      </div>
      <div class="n-lcr-right"></div>
    </div>
  </div>

</div>